import T from './types';

export const setLayoutProps = (props) => ({
  type: T.SET_LAYOUT_PROPS,
  props,
});
